
//NOT EDITABLE!!!
import Hero from "../../components/Hero"
import Footer from "../../components/Footer"

// EDITABLE
import background from "../../assets/img/background.png" //Background
import overlay from "../../assets/img/overlay.png" //overlay
import logo from '../../assets/img/logo.png'; //Logo


function pageLayout( props ) {
    //EDITABLE
    const deskripsi = "Selamat datang kembali di"
    const title1 = "SMP Muhammadiyah 3 Yogyakarta"
    const title2 = ""
    const slogan = '"Terwujudnya siswa beriman, unggul dalam berprestasi dan berwawasan lingkungan"'
    const copyright = "2022 SMP Muhammadiyah 3 Yogyakarta. - Didukung oleh"

    return (
        <div>
            <Hero 
                logo={logo}
                background={background}
                backgroundMobile={background}
                deskripsi={deskripsi}
                title1={title1}
                title2={title2}
                slogan={slogan}
                overlay={overlay}
                appName={props.appName}
            >
                { props.children }
            </Hero>
            <Footer
                copyright={copyright}
            />
        </div>
    );
}


export default pageLayout;